import React from 'react';
import PropTypes from 'prop-types';

import DiveMessageBanner from '../../common/DiveMessageBanner';

const NonFieldErrorBanner = ({ setErrorCallback = () => {}, prContactEmail = '' }) => (
  <DiveMessageBanner messageType="error" additionalClasses="non-field-error" onClose={() => setErrorCallback('')}>
    <p className="non-field-error__message">
      An error has occurred. Please refresh and try again.
      If the problem persists, please reach out to <a href={`mailto:${prContactEmail}`}>{prContactEmail}</a>.
    </p>
  </DiveMessageBanner>
);

NonFieldErrorBanner.propTypes = {
  setErrorCallback: PropTypes.func,
  prContactEmail: PropTypes.string,
};

export default NonFieldErrorBanner;
